const navData = [
  {
    label: 'Home',
    url: '/',
  },
  {
    label: 'Headshots',
    url: '/headshots/',
  },
  {
    label: 'Portraits',
    url: '/portraits/',
  },
  {
    label: 'Rates',
    url: '/rates/',
  },
  {
    label: 'About',
    url: '/about/',
  },
  {
    label: 'Contact',
    url: '/contact/',
  },
]

export default navData
